import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { InfoOutlined } from "@mui/icons-material";

import { CustomAlert, CustomTable, Text } from "../../shared/uiComponents";
import { green200 } from "../../shared/Helpers/colors";
import PendingApproval from "./PendingApproval";
import { TableBody } from "./tableInfo";

import { DispatchProperties, useSelector } from "../../redux/store";
import { getAuthorizationInfoBCBA } from "../../redux/State/clientSlice/insuranceAuthorizationSlice";
import { Loader } from "../../components/StyledComponents";

const BCBAAuthorizationInfo = () => {
  const dispatch = useDispatch<DispatchProperties>();

  const [open, setOpen] = useState<boolean>(false);

  const user = useSelector((state) => state.account.user);
  const role = useSelector((state) => state.account.role);
  const loading = useSelector((state) => state.authorization.loading);
  const authorizations = useSelector((state) => state.authorization.authorizationBCBA);

  useEffect(() => {
    if (!user.id || !role) return;
    const userId = user.id;
    dispatch(getAuthorizationInfoBCBA(userId));
  }, [user, role, dispatch]);

  return !loading ? (
    <div style={{ display: 'flex', alignItems: 'center', gap: 16, width: '100%', flexWrap: 'wrap' }}>
      {!!authorizations?.length ? <div style={{ width: '45%' }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Text size="mediumBold" title={"Authorizations Dashboard"} />

          <InfoOutlined onClick={() => setOpen(true)} />
          <CustomAlert
            open={open}
            onClose={() => setOpen(false)}
            title="Details for authorization period"
            Content={() => (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Text
                  title={"Expires in 3 month"}
                  style={{
                    backgroundColor: "#FFFF5C",
                    width: "max-content",
                    padding: "8px 16px",
                    borderRadius: "12px",
                    marginBottom: "8px",
                  }}
                />
                <Text
                  title={"Active"}
                  style={{
                    backgroundColor: green200,
                    width: "max-content",
                    padding: "8px 16px",
                    borderRadius: "12px",
                    marginBottom: "8px",
                  }}
                />
              </div>
            )}
          />
        </div>
        <CustomTable
          headers={[
            { id: "1", name: "Client" },
            { id: "2", name: "Authorization Period" },
            { id: "3", name: "Authorization Details", width: "150px" },
          ]}
          data={{ query: authorizations }}
          TableBody={TableBody}
          loading={loading}
          hasPagination={false}
        />
      </div> : <></>}
      <PendingApproval />
    </div>
  ) : (
    <Loader />
  );
};

export default BCBAAuthorizationInfo;
